import { IOrganization } from 'app/shared/model/organization.model';

export interface IOrganizationWorkflow {
  id?: number;
  key?: string | null;
  flowUrl?: string | null;
  flowContent?: string | null;
  organization?: IOrganization | null;
}

export const defaultValue: Readonly<IOrganizationWorkflow> = {};
